import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/service' },
    { name: 'Technologies', path: '/techno' },
    { name: 'Gallery', path: '/gallery' },
  ];

  const toggleMobileMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <header className={`header-main ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-inner-main">
          
          {/* 1. Logo Section */}
          {/* Logo Section - Only Image as requested */}
          <div className="header-logo">
            <Link to="/" onClick={closeMenu}>
              <img 
                src="/assets/img/Galaxylogo-remove.png" 
                alt="Galaxy ERP" 
                className="main-logo-img"
              />
            </Link>
          </div>

          {/* 2. Desktop Navigation */}
          <nav className="header-nav desktop-nav">
            {navItems.map((item, index) => (
              <Link key={index} to={item.path} className="nav-link">
                {item.name}
              </Link>
            ))}
          </nav>

          {/* 3. Desktop Contact Button */}
          <div className="header-child">
            <Link to="/contact">
              <button className="head-btn">Contact Us</button>
            </Link>
          </div>

          {/* 4. Mobile Menu Circle Toggle Button */}
          <button className="mobile-menu-circle-btn" onClick={toggleMobileMenu}>
            <div className={`hamburger ${isMenuOpen ? 'is-active' : ''}`}>
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </button>
        </div>

        {/* 5. Mobile Navigation Overlay (Screenshot Style) */}
        <div className={`menu-overlay ${isMenuOpen ? 'show' : ''}`}>
          <nav className="mobile-nav-content">
            {navItems.map((item, index) => (
              <Link 
                key={index} 
                to={item.path} 
                className="mobile-nav-link" 
                onClick={closeMenu}
              >
                {item.name}
              </Link>
            ))}
            
            {/* Mobile Contact Button - Center Capsule */}
            <div className="mobile-btn-wrapper">
              <Link to="/contact" onClick={closeMenu}>
                <button className="head-btn mobile-contact-btn">Contact Us</button>
              </Link>
            </div>
          </nav>
        </div>

      </div>
    </header>
  );
};

export default Header;